import moment from 'moment';
import { NumberToLetter } from 'convertir-nombre-lettre';
import * as xlsx from 'xlsx/xlsx.mjs';
import { saveAs } from 'file-saver';
import qrcode from 'qrcode.vue'



export const generateQR = async (text) => {
    // eslint-disable-next-line no-useless-catch
    try {

        return await qrcode.toDataURL(text);
    } catch (err) {
        throw err;
    }
};



export const exportToTxt=(data,name) =>{

    let filename=name;

    const worksheet = xlsx.utils.json_to_sheet(data);
    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const txtData = xlsx.utils.sheet_to_txt(worksheet, { FS: '\t' });
    const blob = new Blob([txtData], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, filename+'.txt');

};




export const ExportExcel=(type,name, fn, dl,elt) =>{

    //  let name="SheetJSTableExport"
    //var elt = this.$refs.exportable_table;
    var wb = xlsx.utils.table_to_book(elt, {sheet:"Sheet JS"});
    return dl ?
        xlsx.write(wb, {bookType:type, bookSST:true, type: 'base64'}) :
        xlsx.writeFile(wb, fn || ((name + '.') + (type || 'xlsx')));



};


export const ExportExcelMULTISheet=(type,name, fn, dl,elt) =>{

    //  let name="SheetJSTableExport"
    //var elt = this.$refs.exportable_table;
    // var wb
    // var wb = {SheetNames:[], Sheets:{}};
    // var wb = {SheetNames:[], Sheets:{}};


    // var ws = xlsx.utils.table_to_sheet(elt);
    // var ws2 = xlsx.utils.table_to_sheet(elt);
    var wb = xlsx.utils.book_new();

    // xlsx.utils.book_append_sheet(wb, ws, "Sheet 1");
    // xlsx.utils.book_append_sheet(wb, ws2, "Sheet 2");

    for (let i = 0; i < elt.length; i++) {
        xlsx.utils.book_append_sheet(wb, xlsx.utils.table_to_sheet(elt[i].melt), elt[i].name);

    }

    return dl ?
        xlsx.write(wb, {bookType:type, bookSST:true, type: 'base64'}) :
        xlsx.writeFile(wb, fn || ((name + '.') + (type || 'xlsx')));




};


export const randomString = (length=280) => {


    var chars = "0123456789abcdefghijklmnopqrstuvwxyz0123456789ABCDEFG755lkjjhjHIJKLMNOPQRSTUVWXYZ1234567890";

    var output = "";
    var x = 0;
    var i = 0;
    for(x = 0; x < length; x++) {
        i = Math.floor(Math.random() * 62);
        output += chars.charAt(i);
    }



    return output;
};


export const currentDate = () => {
    let now = moment();
    let mdate=now.format("YYYY-MM-DD");
    //let mheure=now.format("HH:mm:ss");

    // console.log(mdate_heure);
    return mdate
};

export const currencyFormatDE = num => {
    var number=Number(num);
    return (
        number
            //.toFixed(2) // always two decimal digits
            .toFixed(0) // always two decimal digits
            .replace('.', ',') // replace decimal point character with ,
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1'+' ') + ' FCFA'
    ) // use . as a separator
};
/*
export const FormatNumber = num => {
    var number=Number(num);
    return (
        number
            .toFixed(6) // always two decimal digits
            .replace('.', ',') // replace decimal point character with ,
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1') + ''
    ) // use . as a separator
};*/

export const FormatNumber = (num) => {
    if (num == null || isNaN(num)) return "0";

    const number = Number(num);
    const isInteger = Number.isInteger(number);

    const fixed = isInteger ? number.toFixed(0) : number.toFixed(3);

    return fixed
        .replace('.', ',') // virgule comme séparateur décimal
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // espace comme séparateur des milliers
};




 export  const getYear1955 = () => {
   // let now = moment();
    var ladate=new Date()
    let arraydate=[];
    let str = 0;
    const startappYear = 1955;
    const currentYear = ladate.getFullYear();
    const goBackYears = currentYear-startappYear;

    for (let i = 0; i <= goBackYears; i++) {
        str = currentYear - i;

        arraydate.push(str)
    }

    return arraydate;

};

 export  const addBusinessDays=(originalDate, numDaysToAdd,isokSunday,isokSaturday) =>{
    const Sunday = 0;
    const Saturday = 6;
    let daysRemaining = numDaysToAdd;
    let clonedate=new Date(originalDate)

    //const myDate = moment(originalDate, 'yyyy-mm-dd').toDate();
    //const myDate = moment(clonedate).format('YYYY-MM-DD');
    const myDate = moment(clonedate);
    // const newDate = originalDate.clone();
    //const newDate = myDate;
    //const newDate = new Date(originalDate);

    while (daysRemaining > 0) {
        //newDate.add(1, 'days');

        myDate.add(1, 'days');

        if (myDate.day() === Sunday || myDate.day() === Saturday) {

            if (isokSunday===1){

                daysRemaining--;

            }

            if (isokSaturday===1){

                daysRemaining--;

            }

        }
        else{
            daysRemaining--;

        }




    }

    //return newDate;
    return myDate.format('YYYY-MM-DD');
};

  export const currentDateTime = () => {
    let now = moment();
    let mdate=now.format("YYYY-MM-DD");
    let mheure=now.format("HH:mm:ss");
    let mdate_heure=mdate+' à '+mheure;
    // console.log(mdate_heure);
    return mdate_heure
};

export const returnMomentjs = () => moment;


  export const formatDate_yyyy_mm_dd = (mdate) => {
    return moment(mdate).format('YYYY-MM-DD');
};

  export const formattime_hh_mm_ss = (mtime) => {
    return moment(mtime,'HHmmss').format("HH:mm:ss");
};

  export const add_day_to_date = (mdate,nbreday) => {
    return moment(mdate).add(parseInt(nbreday), 'days').format("YYYY-MM-DD");
};

 export const checkDateValidity = (mdate)  =>{

    return moment(mdate, "YYYY-MM-DD", true).isValid();

}

 export const checkTimeValidity = (mtime)  =>{

    return  moment(mtime, "HH:mm:ss", true).isValid();

}

 export  const returndifftotwodate = (mdatetimearrive,mdatetimesortie) => {

    const dateC = moment(mdatetimearrive);
    const dateB = moment(mdatetimesortie);


    let res=dateB.diff(dateC);


    return res;
};


  export const getYear2020 = () => {
    let now = moment();
    let arraydate=[];
    let str = 0;
    const startappYear = 2020;
    const currentYear = now.year();
    const goBackYears = currentYear-startappYear;

    for (let i = 0; i <= goBackYears; i++) {
        str = currentYear - i;

        arraydate.push(str)
    }

    return arraydate;

};


 export  const currentYear = () => {
    let now = moment();
    let mdate=now.format("YYYY");
    /// let mheure=now.format("HH:mm:ss");

    // console.log(mdate_heure);
    return mdate
};


 export  const currentMonth = () => {
    let now = moment();
    let mdate=now.format("MM");
    /// let mheure=now.format("HH:mm:ss");

    // console.log(mdate_heure);
    return mdate
};

 export const returnMonthbynumber=val =>{
    var answer = "";




// Only change code below this line
    switch (val) {

        case "01": answer=("Janvier");
            break;
        case "02": answer=("Février");
            break;
        case "03": answer=("Mars");
            break;
        case "04": answer=("Avril");
            break;
        case "05": answer=("Mai");
            break;
        case "06": answer=("Juin");
            break;
        case "07": answer=("Juillet");
            break;
        case "08": answer=("Août");
            break;
        case "09": answer=("Septembre");
            break;
        case "10": answer=("Octobre");
            break;
        case "11": answer=("Novembre");
            break;
        case "12": answer=("Décembre");
            break;}

// Only change code above this line
    return answer;
}


export const cloneobjet = myobjet => {

    return JSON.parse(JSON.stringify(myobjet));
}

export const isNumeric = num => {
    return !isNaN(parseFloat(num)) && isFinite(num);
};

export const array_search = ($search, $array,property) => {


    if (!$array || !Array.isArray($array)) {
        return -1
        // throw new Error('Invalid input: listecaisseacees.accescaisse should be an array');
    }

    return $array.findIndex(element => element[property] === $search);
};


export const getYear = () => {
    let now = moment();
    let arraydate=[];
    let str = 0;
    const startappYear = 2020;
    const currentYear = now.year();
    const goBackYears = currentYear-startappYear;

    for (let i = 0; i <= goBackYears; i++) {
        str = currentYear - i;

        arraydate.push(str)
    }

    return arraydate;

};

export const getnombredejours = (datelicence,datenow) => {

    // let now = moment();
    //let mdate=now.format("YYYY-MM-DD");
    let date2 = moment(datelicence);
    //var current = moment().startOf('day');
    var current = moment(datenow).startOf('day');

//Difference in number of days
    let nbredejour=   moment.duration(date2.diff(current)).asDays();

    return nbredejour;
}


/* ══════════ Impression commune (≈ 115 écrans) ══════════
   Corrections apportées le 2026-10-13, sans changer l'appel existant :
   - format réel : @page posé APRÈS les feuilles, donc il prime sur le
     `@page{size:a3}` de Bootstrap. Taille/orientation prises de $opts.format
     ('A4', 'A4landscape', 'A5', 'A5landscape', 'A3') quand l'écran le passe,
     sinon déduites des feuilles (« landscape » → paysage), A4 par défaut ;
   - aucune feuille fournie (cas des formats A5 non gérés par les écrans) :
     feuilles portrait / paysage par défaut au lieu d'une page brute ;
   - Tailwind servi en local au lieu du CDN (impression hors Internet) ;
   - contenu nettoyé : boutons, éléments `.no-print`, colonnes « Action »,
     champs de saisie remplacés par leur valeur ;
   - la fenêtre se referme après l'impression.
   Tickets thermiques et étiquettes (feuilles ticket / codebarre / stylepost)
   gardent exactement leur comportement : ni @page imposé, ni nettoyage. */
const _IMPR_FORMATS = {
    A4: ['A4', 'portrait'], A4landscape: ['A4', 'landscape'],
    A5: ['A5', 'portrait'], A5landscape: ['A5', 'landscape'],
    A3: ['A3', 'portrait'], A3landscape: ['A3', 'landscape'],
};

const _imprNettoyer = (html) => {
    const tpl = document.createElement('template');
    tpl.innerHTML = html;
    const racine = tpl.content;

    racine.querySelectorAll('button, .no-print, .pbi-no-print, script').forEach(n => n.remove());

    /* Un champ n'imprime que son cadre : on le remplace par sa valeur. */
    racine.querySelectorAll('input, select, textarea').forEach(n => {
        const type = (n.getAttribute('type') || '').toLowerCase();
        if (['hidden', 'button', 'submit', 'checkbox', 'radio', 'file'].includes(type)) { n.remove(); return; }
        let val = n.getAttribute('value') || n.textContent || '';
        if (n.tagName === 'SELECT') {
            const opt = n.querySelector('option[selected]');
            val = opt ? opt.textContent : '';
        }
        const span = document.createElement('span');
        span.textContent = val;
        n.replaceWith(span);
    });

    /* Colonnes « Action(s) » : retirées quand le tableau est régulier. */
    racine.querySelectorAll('table').forEach(table => {
        const entete = table.querySelector('thead tr') || table.querySelector('tr');
        if (!entete) return;
        const cellules = Array.from(entete.children);
        if (cellules.some(c => (parseInt(c.getAttribute('colspan')) || 1) > 1)) return;
        const idx = cellules.findIndex(c => /^actions?\s*:?$/i.test((c.textContent || '').trim()));
        if (idx < 0) return;
        /* Ligne par ligne, on retrouve la cellule qui couvre la colonne : seule
           elle disparaît (ou perd une unité de colspan si elle en couvre plusieurs). */
        table.querySelectorAll('tr').forEach(tr => {
            let pos = 0;
            for (const c of Array.from(tr.children)) {
                const span = parseInt(c.getAttribute('colspan')) || 1;
                if (idx >= pos && idx < pos + span) {
                    if (span > 1) c.setAttribute('colspan', String(span - 1)); else c.remove();
                    break;
                }
                pos += span;
            }
        });
    });

    const div = document.createElement('div');
    div.appendChild(racine.cloneNode(true));
    return div.innerHTML;
};

export const impression = (printContent,$styles,$windowsname='Print',$scripts=[],$opts={}) => {

    return new Promise((resolve) => {

    const base = process.env.VUE_APP_URL || '/';
    let styles = Array.isArray($styles) ? $styles.slice() : [];
    const scripts = (Array.isArray($scripts) ? $scripts : []).map(s =>
        /cdn\.tailwindcss\.com/.test(s) ? base + 'print/tailwindcss3.4.17' : s);

    const special = styles.some(s => /ticket|codebarre|stylepost/i.test(s));

    let contenu = printContent;
    let pageCss = '';

    if (!special) {
        const fmt = _IMPR_FORMATS[($opts && $opts.format) || ''];
        const paysage = fmt ? fmt[1] === 'landscape' : styles.some(s => /landscape/i.test(s));
        const taille = fmt ? fmt[0] : 'A4';

        if (styles.length === 0) {
            styles = paysage
                ? [base + 'print/bootstrap.min.css', base + 'print/stylelandscape1.css', base + 'print/stylelandscape.css']
                : [base + 'print/bootstrap.min.css', base + 'print/styleportrait.css'];
        }
        /* Complément commun (classes Tailwind des blocs d'impression), en dernier,
           sauf pour le gabarit autonome rapport-pro qui n'en a pas besoin. */
        if (!styles.some(s => /custom_print_a4|rapport-pro/.test(s))) styles.push(base + 'print/custom_print_a4.css');

        pageCss = `<style>
@page { size: ${taille} ${paysage ? 'landscape' : 'portrait'}; margin: 10mm; }
@media print { html, body { background: #fff !important; } }
thead { display: table-header-group; } tfoot { display: table-footer-group; }
tr, img { page-break-inside: avoid; break-inside: avoid; }
img { max-width: 100%; }
.no-print, .pbi-no-print { display: none !important; }
${taille === 'A5' ? '.table td, .table th, td, th { font-size: 9px !important; } body { font-size: 10px; }' : ''}
</style>`;

        try { contenu = _imprNettoyer(printContent); } catch (e) { contenu = printContent; }
    }

    const width = 800;
    const height = 500;
    const left = (screen.width / 2) - (width / 2);
    const top = (screen.height / 2) - (height / 2);
    const printWindow = window.open('', '', `width=${width},height=${height},top=${top},left=${left}`);
    if (!printWindow) {
        if (window.toastr) window.toastr['warning']("Le navigateur a bloqué la fenêtre d'impression : autorisez les fenêtres pop-up pour ce site.", '<b></b>');
        resolve(false);
        return;
    }

    /* Sans doctype, comme avant : les gabarits existants ont été mis au point
       dans ce mode de rendu, on ne le change pas sous leurs pieds. */
    printWindow.document.write(`<html><head><meta charset="utf-8"><title>${$windowsname}</title>`);

    for (let $line of scripts){

        printWindow.document.write(` <script src="${$line}"></script>`);

    }

    for (let $line of styles){

        printWindow.document.write(`<link rel="stylesheet" href="${$line}">`);

    }

    printWindow.document.write(pageCss);
    printWindow.document.write('</head><body >');
    printWindow.document.write(contenu);
    // Déclencher l'impression après chargement complet (feuilles et scripts), puis refermer.
    printWindow.document.write(`<scr` + `ipt>window.addEventListener('load',function(){setTimeout(function(){window.print();},400);});</scr` + `ipt>`);
    printWindow.document.write('</body></html>');
    printWindow.document.close();

    printWindow.onafterprint = function () {
        resolve(true);
        if (!special) setTimeout(function () { try { printWindow.close(); } catch (e) { /* déjà fermée */ } }, 100);
    };
    });

}

export const isset = (accessor) => {
    try {
        // Note we're seeing if the returned value of our function is not
        // undefined or null

        return accessor !== undefined && accessor !== null && accessor !== 'undefined' && accessor !== 'null'
    } catch (e) {
        // And we're able to catch the Error it would normally throw for
        // referencing a property of undefined
        return false
    }


}

export const issetArray = (value) => {
    try {
        return Array.isArray(value) && value !== null && typeof value !== 'undefined';
    } catch (e) {
        // And we're able to catch the Error it would normally throw for
        // referencing a property of undefined
        return false
    }


}

export const issetObject = (value) => {
    try {
        return value !== null && value !== undefined && Object.prototype.toString.call(value) === '[object Object]';
    } catch (e) {
        // And we're able to catch the Error it would normally throw for
        // referencing a property of undefined
        return false
    }


}

export const isValidDateString = (datestring) => {

    const checkdate=moment(datestring,"YYYY-MM-DD",true);

    return checkdate.isValid();


}


export const mergePermissionTrees = (templateNodes, stored = [])  =>{
    // detect stored format
    const storedIsFlat =
        Array.isArray(stored) && stored.length > 0 && typeof stored[0] === "string";

    // Build a set of flattened paths if stored is flat
    const storedFlatSet = new Set();
    if (storedIsFlat) {
        for (const p of stored) {
            if (typeof p === "string") storedFlatSet.add(p);
        }
    }

    // If stored is a tree, build a map of id->enabled and optionally fullPaths->enabled
    const storedIdMap = new Map(); // id -> node (the stored node)
    const storedPathSet = new Set(); // fullPath -> true if enabled (useful when stored is tree)
    function buildStoredMaps(nodes, parentPath = "") {
        if (!Array.isArray(nodes)) return;
        for (const n of nodes) {
            const path = parentPath ? `${parentPath}.${n.id}` : n.id;
            storedIdMap.set(n.id, n); // fallback by id (useful but ambiguous)
            if (n.enabled) storedPathSet.add(path);
            if (n.children && n.children.length) buildStoredMaps(n.children, path);
        }
    }
    if (!storedIsFlat && Array.isArray(stored)) buildStoredMaps(stored);

    // recursive merge keeping full path to match flat stored entries
    function mergeNode(tNode, parentPath = "") {
        const fullPath = parentPath ? `${parentPath}.${tNode.id}` : tNode.id;

        // Determine enabled:
        let enabled;

        if (storedIsFlat) {
            // If stored is flat, check exact fullPath presence
            enabled = storedFlatSet.has(fullPath);
        } else {
            // stored is tree (or maybe undefined)
            // Priority:
            // 1. If storedPathSet contains fullPath => enabled true
            // 2. Else if storedIdMap has node with same id and it has explicit enabled boolean => use it
            // 3. Else fallback to template's enabled or false
            if (storedPathSet.has(fullPath)) {
                enabled = true;
            } else if (storedIdMap.has(tNode.id) && typeof storedIdMap.get(tNode.id).enabled === "boolean") {
                enabled = storedIdMap.get(tNode.id).enabled;
            } else {
                enabled = typeof tNode.enabled === "boolean" ? tNode.enabled : false;
            }
        }

        // Merge children recursively from template children (we don't trust stored structure as source of truth)
        const children = Array.isArray(tNode.children)
            ? tNode.children.map((c) => mergeNode(c, fullPath))
            : [];

        // Optionally gather legacy children present in stored but absent in template
        let legacy = [];
        if (!storedIsFlat && Array.isArray(stored)) {
            // Find stored node for this fullPath (walk stored)
            const storedNode = findStoredNodeByPath(stored, fullPath);
            if (storedNode && Array.isArray(storedNode.children)) {
                const tChildIds = new Set((tNode.children || []).map((c) => c.id));
                legacy = storedNode.children.filter((c) => !tChildIds.has(c.id));
            }
        }

        const merged = {
            id: tNode.id,
            label: tNode.label ?? tNode.id,
            enabled,
        };
        if (children.length) merged.children = children;
        if (legacy.length) merged.legacy = legacy;

        return merged;
    }

    // helper to find stored node by fullPath in tree stored format
    function findStoredNodeByPath(nodes, path) {
        if (!Array.isArray(nodes)) return null;
        const parts = path.split(".");
        let currentNodes = nodes;
        let node = null;
        for (const part of parts) {
            node = currentNodes.find((n) => n.id === part);
            if (!node) return null;
            currentNodes = node.children || [];
        }
        return node;
    }

    return templateNodes.map((t) => mergeNode(t, ""));
}




export const groupByKey=(array, key)=> {
    return array
        .reduce((hash, obj) => {
            if(obj[key] === undefined) return hash;
            return Object.assign(hash, { [obj[key]]:( hash[obj[key]] || [] ).concat(obj)})
        }, {})
};


export const currencyFormatDEnotdevice = num => {
    var number=Number(num);
    return (
        number
            //.toFixed(2) // always two decimal digits
            /*.toFixed(0) // always two decimal digits
            .replace('.', ',') // replace decimal point character with ,
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')*/

            .toFixed(4) // always two decimal digits
            .replace('.', ',') // replace decimal point character with ,
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1'+'')


    ) // use . as a separator
}


export const currencyFormatMonney = num => {
    var number=Number(num);
    return (
        number
            //.toFixed(2) // always two decimal digits
            .toFixed(0) // always two decimal digits
            .replace('.', ',') // replace decimal point character with ,
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1'+' ') + ''
    ) // use . as a separator
}

export const parseFCFA = value => {
    // Si c'est déjà un nombre
    if (typeof value === "number") {
        return value;
    }

    if (value == null || value === "") {
        return 0;
    }

    // Conversion en chaîne
    value = String(value).trim();

    // Suppression de "FCFA"
    value = value.replace(/FCFA/i, "").trim();

    // Suppression des espaces (séparateurs de milliers)
    value = value.replace(/\s/g, "");

    // Remplacement de la virgule décimale par un point
    value = value.replace(",", ".");

    const number = parseFloat(value);

    return isNaN(number) ? 0 : number;
}
export const NumbertoLettre = chiffre => {
 
   chiffre= parseFloat(chiffre);

    var number=Number(chiffre); 

    return NumberToLetter(number)
}

   export const getPUisupermacher = ($article, qty = 1) => {
  let paliers = $article.pv;
  if (typeof paliers === 'string') {
    try { paliers = JSON.parse(paliers); } catch (e) { paliers = []; }
  }
  if (!Array.isArray(paliers) || paliers.length === 0) {
    return parseFloat($article.pu) || 0;
  }

  const q = parseFloat(qty) || 0;

  // TOUS les paliers qui contiennent la quantité (pas juste le premier)
  const matches = paliers.filter(p =>
      p.mtyprix === 'prixvente' &&
      q >= parseFloat(p.min) &&
      q <= parseFloat(p.max)
  );

  if (matches.length === 0) return parseFloat($article.pu) || 0;

  // Chevauchement → on prend le PRIX LE PLUS BAS
  const pu = Math.min(...matches.map(p => parseFloat(p.pu) || 0));
  return pu;
}




export const moisEnLettre = mois => {
    switch (mois) {
        case 1:
            return "Janvier";
        case 2:
            return "Février";
        case 3:
            return "Mars";
        case 4:
            return "Avril";
        case 5:
            return "Mai";
        case 6:
            return "Juin";
        case 7:
            return "Juillet";
        case 8:
            return "Août";
        case 9:
            return "Septembre";
        case 10:
            return "Octobre";
        case 11:
            return "Novembre";
        case 12:
            return "Décembre";
        default:
            return "Mois invalide";
    }
}




export const  triecroissant  = (mvalue,key) => {
    // Sort by alphabetical order

    let orderedStories = mvalue.sort((a, b) => {
        // if (this.sortBy == 'alphabetically') {


        /* let fa = a[key].toLowerCase(),
             fb = b[key].toLowerCase()*/

        let fa = typeof a[key] === 'string' ? a[key].toLowerCase() : a[key],
            fb = typeof b[key] === 'string' ? b[key].toLowerCase() : b[key];

        if (fa < fb) {
            return -1
        }
        if (fa > fb) {
            return 1
        }
        return 0
        // }

    })

    return orderedStories;

}

export const  triedecroissant  = (mvalue,key) => {
    // Sort by alphabetical order

    let orderedStories = mvalue.sort((a, b) => {

        let fa = typeof a[key] === 'string' ? a[key].toLowerCase() : a[key],
            fb = typeof b[key] === 'string' ? b[key].toLowerCase() : b[key];


        if (fa > fb) {
            return -1
        }
        if (fa < fb) {
            return 1
        }
        return 0


    })

    return orderedStories;

}

export const   getPeriod = (param) => {
    // Date de fin : aujourd'hui
    let dateFin = moment();

    // Variable pour la date de début
    let dateDebut;

    // Vérifier le paramètre et calculer la date de début
    const unit = param.slice(-1);  // Récupère l'unité (d, w, M)
    const amount = parseInt(param.slice(0, -1));  // Récupère le nombre

    /*
    switch (unit) {
        case 'd':
           // dateDebut = moment();
           // dateDebut = moment().subtract(amount, 'days');

            dateDebut = moment().startOf('day');
            dateFin = moment().endOf('day');

            break;
        case 'W':
           // dateDebut = moment().subtract(amount, 'weeks');

            dateDebut = moment().subtract(amount, 'weeks').startOf('isoWeek');
            dateFin = moment().subtract(amount, 'weeks').endOf('isoWeek');

            break;
        case 'M':
            //dateDebut = moment().subtract(amount, 'months');

            dateDebut = moment().subtract(amount, 'months').startOf('month');
            dateFin = moment().subtract(amount, 'months').endOf('month');

            break;
        case 'Y':
           // dateDebut = moment().subtract(amount, 'years');

            dateDebut = moment().subtract(amount, 'years').startOf('year');
            dateFin = moment().subtract(amount, 'years').endOf('year');

            break;
        default:
            //dateDebut = moment();
            dateDebut = moment().startOf('day');
            dateFin = moment().endOf('day');

           // throw new Error('Paramètre invalide. Utilisez "d" pour jour, "w" pour semaine, ou "M" pour mois.');
    }*/

    switch (unit) {
        case 'd':
            dateDebut = moment().startOf('day');
            dateFin = moment().endOf('day');
            break;
        case 'W':
            if (amount === 1) {
                dateDebut = moment().startOf('isoWeek');
                dateFin = moment().endOf('isoWeek');
            } else {
                dateDebut = moment().subtract(amount - 1, 'weeks').startOf('isoWeek');
                dateFin = moment().endOf('isoWeek');
            }
            break;
        case 'M':
            if (amount === 1) {
                dateDebut = moment().startOf('month');
                dateFin = moment().endOf('month');
            } else {
                dateDebut = moment().subtract(amount - 1, 'months').startOf('month');
                dateFin = moment().endOf('month');
            }
            break;
        case 'Y':
            if (amount === 1) {
                dateDebut = moment().startOf('year');
                dateFin = moment().endOf('year');
            } else {
                dateDebut = moment().subtract(amount - 1, 'years').startOf('year');
                dateFin = moment().endOf('year');
            }
            break;
        default:
            dateDebut = moment().startOf('day');
            dateFin = moment().endOf('day');
        // throw new Error('Paramètre invalide. Utilisez "d" pour jour, "W" pour semaine, "M" pour mois, ou "Y" pour année.');
    }

    return {
        dateDebut: dateDebut.format('YYYY-MM-DD'),
        dateFin: dateFin.format('YYYY-MM-DD')
    };
}







/*
module.exports = {

    randomString,
    currentDate
    returnMonthbynumber,
     addBusinessDays,
    currentDateTime,
    formatDate_yyyy_mm_dd,
   formattime_hh_mm_ss,
    add_day_to_date,
    checkDateValidity,
    checkTimeValidity,
    returndifftotwodate,
    getYear2020,
    getYear1955,
    currentYear,


}
*/
